export default __webpack_public_path__ + "static/media/texp10.b320e55e.png";